export default __webpack_public_path__ + "icons/favicon-9d3d7fd7b0c37310a634b51392f5b54c.ico";